import { queryClient } from '@/shared/api/query-client.instance';
import { QueryClientProvider as ReactQueryProvider } from '@tanstack/react-query';
import type { FC, PropsWithChildren } from 'react';

export const QueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ReactQueryProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools /> */}
    </ReactQueryProvider>
  );
};
